import { eTipoPermissao } from '@/enums/ePermissoes';

const permissao = eTipoPermissao.ESTRUTURAINSPECAOTRANSPORTENOVO_MENU_1100400599;

export default [
  {
    description: 'Estrutura de Inspeção do Transporte',
    path: '/transporte/traestruturainspecao',
    name: 'traestruturainspecao',
    redirect: { name: 'traestruturainspecao-veiculo' },
    meta: { permissions: [permissao] },
    goesToMenu: false,
  },
  {
    description: 'Estrutura de Inspeção de Veículos',
    path: '/transporte/traestruturainspecao/veiculo',
    name: 'traestruturainspecao-veiculo',
    component: () => import('@/views/transporte/traestruturainspecao/Index.vue'),
    meta: { permissions: [permissao], tipoEstrutura: 1101 },
    goesToMenu: true,
  },
  {
    description: 'Estrutura de Inspeção de Motoristas',
    path: '/transporte/traestruturainspecao/motorista',
    name: 'traestruturainspecao-motorista',
    component: () => import('@/views/transporte/traestruturainspecao/Index.vue'),
    meta: { permissions: [permissao], tipoEstrutura: 1102 },
    goesToMenu: true,
  },
];
